export default __webpack_public_path__ + "assets/models/891c9c40c41b789cab7ecaffb8a12f46.glb";